<template>
    <div class="user_all">
        <div>
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8}"
                   :placeholder="this.$t('title.Please_enter_content')"
                    v-model="textarea"
                    style="width: 50%"
            >
            </el-input>

        </div>
        <el-button type="primary" style="margin-top: 30px" @click="trs()">{{ $t('title.format') }}</el-button>
        <div class="layout" style="margin-top: 30px">
            <div class="setting">
                <ul>
                    <li>
                        <label>{{ $t('title.theme') }}</label>
                        <select v-model="theme">
                            <option value="">{{ this.$t('title.default') }}</option>
                            <option value="one-dark">one-dark</option>
                            <option value="vs-code">vs-code</option>
                        </select>
                    </li>
                    <li>
                        <label>{{ $t('title.Collapse_all') }}</label>
                        <select v-model="closed">
                            <option :value="false">false</option>
                            <option :value="true">true</option>
                        </select>
                    </li>

                    <li>
                        <label>deep</label>
                        <select v-model="deep">
                            <option v-for="item in 10" :value="item">{{item}}</option>
                        </select>
                    </li>
                    <li>
                        <label>font-size</label>
                        <select v-model="fontSize">
                            <option v-for="item in 10" :value="item+11">{{item+11}}</option>
                        </select>
                    </li>
                    <li>
                        <label for="line-height">line-height</label>
                        <select v-model="lineHeight">
                            <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
                        </select>
                    </li>

                </ul>
            </div>
        </div>
        <div class="content">
            <json-view :data="json" :theme="theme" :deep="deep" :iconStyle="iconStyle" :fontSize="fontSize"
                       :lineHeight="lineHeight" :closed="closed" :iconColor="iconColor"/>
        </div>
    </div>

</template>

<script>
    import jsonView from '../../json-view/index.vue';

    export default {
        name: "Json",
        components: {jsonView},
        data() {
            return {
                json: {},
                theme: '',
                fontSize: 14,
                lineHeight: 24,
                deep: 3,
                iconStyle: 'square',
                closed: false,
                color1: '',
                color2: '',
                textarea: ''
            }
        },
        computed: {
            iconColor() {
                const {color1, color2} = this;

                if (color1 && color2) {
                    return [color1, color2];
                } else {
                    return [];
                }
            }
        },
        methods: {
            trs() {
                this.json = JSON.parse(this.textarea)
            }
        }
    }
</script>

<style scoped lang="less">
    #app {
        .layout {
            /*width: 1200px;*/
            /*margin: 0 auto;*/

            h1 {
                font-size: 26px;
                font-weight: 400;
                margin: 12px 0;
            }

            a {
                display: block;
                background-color: #f8f8f9;
                border-radius: 4px;
                padding: 8px 16px;
                border: 1px solid #edeff0;
                border-radius: 4px;
                margin-bottom: 20px;
                text-decoration: none;
                color: #2d8cf0;
            }

            .setting {
                border: 1px solid #ccc;
                padding: 10px 20px;

                h3 {
                    line-height: 1.6;
                    font-size: 18px;
                    color: #333;
                }
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                align-items: center;

                li {
                    display: flex;
                    align-items: center;
                    padding: 10px 0;
                    padding-right: 20px;

                    label {
                        font-size: 13px;
                        padding-right: 10px;
                        color: #333;
                    }

                    select {
                        display: block;
                        width: 80px;
                        height: 28px;
                        background: #fff;
                    }
                }
            }


        }

        .content {
            border: 1px solid #ccc;
            border-top: none;
            max-height: 500px;
            overflow: auto;
            /*.content-wrap {*/
            /*   display: none !important;*/
            /*   background-color: rebeccapurple;*/
            /*}*/
        }
    }
</style>
<style scoped>
    .user_all {
        padding: 20px 30px;
    }

    .user_search {
        margin-bottom: 30px;
    }
</style>
